import { library, dom } from "@fortawesome/fontawesome-svg-core";

// You have to import individually because our bundler isn't very smart...
import { faInstagram } from "@fortawesome/free-brands-svg-icons/faInstagram";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons/faLinkedin";
import { faFacebookSquare } from "@fortawesome/free-brands-svg-icons/faFacebookSquare";
import { faTwitterSquare } from "@fortawesome/free-brands-svg-icons/faTwitterSquare";
import { faVimeoSquare } from "@fortawesome/free-brands-svg-icons/faVimeoSquare";
import { faYoutubeSquare } from "@fortawesome/free-brands-svg-icons/faYoutubeSquare";

library.add([
    faInstagram,
    faLinkedin,
    faFacebookSquare,
    faTwitterSquare,
    faVimeoSquare,
    faYoutubeSquare
]);

dom.watch();